const ViewBusinessServiceApply = () => import('../modules/xmsb/energy/operators/ViewBusinessServiceApplyGzl')

export default [
  {

    path: '/businessserviceapplyview',
    name: 'businessserviceapplyview',
    component: ViewBusinessServiceApply,
    meta: {
      title: '申报支持电子商务服务类企业发展项目专项资金',
      fullscreen: true,
    },
  },
]
